module.exports = __webpack_public_path__ + "img/drt19.49daf04e.png";